import {Component, Input} from '@angular/core';
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {DialogRef} from "@fundamental-ngx/core/dialog";

export class ConfirmationDialogConfig {
    headerGlyph: IconProp = "xmark";
    title: string;
    confirmText: string;
    cancelText: string;
    bodyText: string;
    constructor(init?: Partial<ConfirmationDialogConfig>) {
        Object.assign(this, init);
    }
}

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent {
  @Input() config: ConfirmationDialogConfig;
  constructor(public dialogRef: DialogRef) {
      this.config = dialogRef.data || new ConfirmationDialogConfig();
  }
}
